import { STORE_ID } from "constants/AuthConstant";

export const getCurrentStoreId = () => {
  if (typeof localStorage === "undefined") {
    return null;
  }

  const value = localStorage.getItem(STORE_ID);

  if (!value || value === "null" || value === "undefined") {
    return null;
  }

  return value;
};

export const withCurrentStore = (payload = {}, key = "currentStoreId") => {
  if (payload?.[key]) {
    return payload;
  }

  return {
    ...payload,
    [key]: getCurrentStoreId(),
  };
};

export const withCurrentStoreInQuery = (payload = {}) => {
  if (payload?.query?.currentStoreId) {
    return payload;
  }

  return {
    ...payload,
    query: {
      ...(payload.query || {}),
      currentStoreId: getCurrentStoreId(),
    },
  };
};

export const currentStoreParams = (params = {}) => ({
  ...params,
  currentStoreId: params?.currentStoreId ?? getCurrentStoreId(),
});
